import Vue from 'vue'
import Router from 'vue-router'
import Landingpage from '@/views/landingpage.vue'
import { publicPath } from '../vue.config';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: publicPath,
    routes: [
        {
            path: '/',
            component: Landingpage
		}
	]
})
